import styled from 'styled-components';

export const StyledSeriesList = styled.div`
    width: ${({ ismobile }) => (ismobile ? '100%' : '300px')};
    display: flex;
    flex-direction: column;
    align-items: center;
`;
